// Tiny dev-only logger — strips logs in production builds.
const isDev = process.env.NODE_ENV !== 'production';

export const devError = (...args) => {
  if (isDev) console.error(...args);
};

export const devWarn = (...args) => {
  if (isDev) console.warn(...args);
};
